// extracted by mini-css-extract-plugin
export var centerList = "_ja-6";
export var centerLoc = "_ja-a";
export var centerName = "_ja-9";
export var centerOptionBody = "_ja-8";
export var centerRow = "_ja-7";
export var centerStatus = "_ja-b";
export var empty = "_ja-5";
export var externalIcon = "_ja-c";
export var fieldHeader = "_ja-2";
export var fieldHelp = "_ja-4";
export var fieldLabel = "_ja-3";
export var panel = "_ja-0";
export var removeBtn = "_ja-d";
export var section = "_ja-1";